export const environment = {
  production: true,
  apiBaseUrl: 'https://priv.progetto-sole.blank-software.it/api',
  dominioSito: 'https://progetto-sole.com',
  timeZone: 'Europe/Rome',
};
